"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var TimeLabel = function TimeLabel(_ref) {
  var _ref$ms = _ref.ms,
      ms = _ref$ms === void 0 ? 0 : _ref$ms;
  var time = new Date(ms || 0); // still need this in case ms = NaN

  var isHourTimeLabel = time.getUTCHours() >= 1;
  return time.toISOString().slice(isHourTimeLabel ? 11 : 14, -5);
};

var _default = TimeLabel;
exports["default"] = _default;